import { render } from "./BackgroundSlider.vue?vue&type=template&id=3944cf84"
import script from "./BackgroundSlider.vue?vue&type=script&lang=js"
export * from "./BackgroundSlider.vue?vue&type=script&lang=js"

import "./BackgroundSlider.vue?vue&type=style&index=0&id=3944cf84&lang=css"

import exportComponent from "/Users/user/Projects/Vue/one-invoice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__